import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  Input,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import {
  FullCalendarComponent,
  FullCalendarModule,
} from '@fullcalendar/angular';
import {
  CalendarOptions,
  DateSelectArg,
  EventClickArg,
  EventApi,
  DatesSetArg,
  EventDropArg,
} from '@fullcalendar/core';
import { EventResizeDoneArg } from '@fullcalendar/interaction';

import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import deLocale from '@fullcalendar/core/locales/de-at';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import {
  Booking,
  BookingChange,
  ChangeEventType,
  FilterState,
  newGuideInterface,
  ShipInterface,
  UserInterface,
} from '../../core/models';
import { SimpleBookingComponent } from '../modals/simple-booking.component';
import { AuthService } from '../../services/auth/auth.service';

import { Timestamp } from '@angular/fire/firestore';
import { BookingDataService } from '../../services/booking-data/booking-data.service';
import { BookingService } from '../../services/resources/booking.service';
import { Observable, Subscription } from 'rxjs';
import { BookingsToEventsPipe } from '../../core/bookings-to-events.pipe';
import { SimpleBookingEditComponent } from '../modals/simple-booking-edit.component';
import { SimpleCheckModalComponent } from '../modals/simple-check-modal.component';
import {
  formatUnixToTimeString,
  getCalendarWeek,
  sortGuides,
  utcCalendarDay,
} from '../../core/booking-from.utils';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling
import { format, parseISO } from 'date-fns';
import _, { isEmpty } from 'lodash';

import { DashboardFilterService } from '../../services/filter/dashboard-filter.service';
import { BookingSearchComponent } from '../dashboard/booking-search.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  animate,
  state,
  style,
  transition,
  trigger,
  AnimationEvent as NgAnimationEvent,
} from '@angular/animations';
@Component({
  selector: 'app-shipcalendar',
  imports: [
    CommonModule,
    FullCalendarModule,
    SimpleBookingComponent,
    SimpleBookingEditComponent,
    SimpleCheckModalComponent,
    BookingsToEventsPipe,
  ],
  standalone: true,
  template: `
    <div class="w-full flex flex-col">
      <!-- Collapsed line / header -->
      <div class="w-full flex items-center justify-between px-4 py-2 border-b">
        <div class="min-w-0">
          <span class="block truncate text-lg font-semibold italic">
            {{ ship.companyName }} - {{ ship.shipName }}
          </span>
        </div>

        <button
          type="button"
          class="inline-flex items-center justify-center rounded-md p-2 hover:bg-columbus-blue-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-columbus-blue-400"
          (click)="handleCalendarToggle()"
          [attr.aria-expanded]="calendarVisible()"
          [attr.aria-label]="
            calendarVisible()
              ? 'Collapse ship calendar'
              : 'Expand ship calendar'
          "
        >
          <svg
            class="h-5 w-5 transition-transform duration-200"
            [class.rotate-180]="calendarVisible()"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M6 9l6 6 6-6"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>

      <!-- Expandable content -->
      <div
        class="overflow-hidden"
        [@expandCollapse]="calendarVisible() ? 'expanded' : 'collapsed'"
        [attr.aria-hidden]="!calendarVisible()"
      >
        <div class="w-full calendar-container px-2 pb-2 pt-2">
          <full-calendar
            #calendar
            *ngIf="calendarInitialized()"
            [options]="calendarOptions()"
            [events]="bookings$ | async | bookingsToEvents"
          >
            <ng-template #eventContent let-arg>
              <div class="relative w-full h-full overflow-hidden">
                <div class="flex w-full justify-between">
                  <b>{{ arg.timeText }}</b>
                </div>
                <div
                  class="event-content"
                  style="overflow: hidden; text-overflow: ellipsis; max-height: 100%;"
                >
                  <i [innerHTML]="arg.event.title"></i>
                </div>

                <!-- Dots unten links -->
                <div class="absolute bottom-1 left-1 flex gap-x-1">
                  <!-- Accounting Note (rot) -->
                  <span
                    *ngIf="
                      arg.event.extendedProps?.booking?.accounting
                        ?.accountingNote ||
                      arg.event.extendedProps?.booking?.accountingNote
                    "
                    class="relative flex size-2.5"
                  >
                    <span
                      class="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-200 opacity-75"
                    ></span>
                    <span
                      class="relative inline-flex size-2.5 rounded-full bg-red-400"
                    ></span>
                  </span>

                  <!-- Abgerechnet (grün) -->
                  <span
                    *ngIf="
                      arg.event.extendedProps?.booking?.accounting?.billing
                        ?.billed
                    "
                    class="relative flex size-2.5"
                  >
                    <span
                      class="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-200 opacity-75"
                    ></span>
                    <span
                      class="relative inline-flex size-2.5 rounded-full bg-green-400"
                    ></span>
                  </span>
                </div>
              </div>
            </ng-template>
          </full-calendar>
        </div>
      </div>
    </div>

    <div *ngIf="calendarModaltoggler && newBooking">
      <app-simple-booking
        [newBooking]="newBooking"
        (close)="onCloseCalendarModal($event)"
      ></app-simple-booking>
    </div>
    <div *ngIf="calendarEditModaltoggler && editBooking">
      <app-simple-booking-edit
        [editBooking]="editBooking"
        (delete)="onDeleteBooking()"
        (close)="onCloseCalendarEditModal($event)"
        (goToDetail)="onGoToDetailPage()"
        (copyBooking)="onCopyBooking($event)"
      ></app-simple-booking-edit>
    </div>

    <div *ngIf="calendarDeleteModaltoggler && editBooking">
      <app-simple-check-modal
        [title]="'Buchung Löschen?'"
        [message]="'Möchten Sie die Buchung Löschen?'"
        [positiveButtonText]="'Bestätigen'"
        [negativeButtonText]="'Abbrechen'"
        (close)="onDeleteModalClose($event)"
      />
    </div>

    <div *ngIf="changeBookingToggler && editBooking">
      <app-simple-check-modal
        [title]="'Buchung ändern?'"
        [message]="changeBookingText"
        [positiveButtonText]="'Bestätigen'"
        [negativeButtonText]="'Abbrechen'"
        (close)="onChangeModalClose($event)"
      />
    </div>
  `,
  styles: `
    ::ng-deep .fc-event-title {
      white-space: normal !important;
      overflow: hidden !important;
      text-overflow: ellipsis !important;
    }

    ::ng-deep .event-content {
      max-height: 100%;
      overflow: hidden;
    }
  `,
  animations: [
    trigger('expandCollapse', [
      state(
        'collapsed',
        style({
          height: '0px',
          opacity: 0,
          transform: 'translateY(-4px)',
        }),
      ),
      state(
        'expanded',
        style({
          height: '*',
          opacity: 1,
          transform: 'translateY(0)',
        }),
      ),
      transition(
        'collapsed <=> expanded',
        animate('220ms cubic-bezier(0.2,0,0,1)'),
      ),
    ]),
  ],
})
export class ShipcalendarComponent implements OnInit {
  @ViewChild('calendar') calendarComponent?: FullCalendarComponent;

  @ViewChild(BookingSearchComponent)
  bookingSearch?: BookingSearchComponent;

  @Input({ required: true }) ship!: ShipInterface;

  authService = inject(AuthService);
  bookingDataService = inject(BookingDataService);
  changeDetector = inject(ChangeDetectorRef);
  router = inject(Router);
  bookingService = inject(BookingService);
  filterService = inject(DashboardFilterService);
  private readonly destroyRef = inject(DestroyRef);

  calendarVisible = signal(false);
  calendarOptions = signal<CalendarOptions>({});
  currentEvents = signal<EventApi[]>([]);

  calendarModaltoggler = false;
  calendarEditModaltoggler = false;
  newBooking: Booking | undefined = undefined;
  editBooking: Booking | undefined = undefined;
  oldBooking: Booking | undefined = undefined;

  calendarDeleteModaltoggler = false;
  currentStartDate: Date | undefined = undefined;
  bookings$: Observable<Booking[]> | undefined = undefined;
  bookings: Booking[] = [];

  changeBookingToggler = false;
  changeBookingText = '';

  bookingSubscription$: Subscription | undefined = undefined;
  filterServiceSubscription$: Subscription | undefined = undefined;

  initalDate: Date | undefined = undefined;
  searchBookings: Booking[] = [];
  searchTerm = '';
  protected showEmpty = true;

  calendarInitialized = signal(false);

  ngOnInit(): void {
    if (this.ship) {
      this.initCalendar();
    }
  }

  getInitialDate() {
    this.filterService.filters$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((fs: FilterState) => {
        if (fs && fs.savedDate) {
          this.initalDate = parseISO(fs.savedDate);
        } else {
          this.initalDate = new Date();
        }

        this.searchBookings = fs.loadedBookings;
        this.searchTerm = fs.searchTerm;
        this.showEmpty = fs.showEmpty;
      });

    return this.initalDate;
  }

  getCalendarApi() {
    const fullCalendarElement = this.calendarComponent?.getApi();
    return fullCalendarElement;
  }

  initCalendar() {
    this.calendarOptions.set({
      plugins: [interactionPlugin, timeGridPlugin, listPlugin],
      headerToolbar: false,
      initialView: 'timeGridWeek',
      weekends: true,
      editable: true,
      height: 'auto',
      allDaySlot: false,
      selectable: true,
      selectMirror: true,
      dayMaxEvents: true,
      select: this.handleDateSelect.bind(this),
      eventClick: this.handleEventClick.bind(this),
      eventsSet: this.handleEvents.bind(this),
      locales: [{ ...deLocale, allDayText: '' }],
      locale: 'de-at',

      slotMinTime: '07:00:00',
      slotMaxTime: '23:00:00',
      slotDuration: '00:15:00',

      // Custom time axis configuration
      slotLabelInterval: '01:00:00', // Show labels only every hou
      slotLabelFormat: {
        hour: '2-digit', // Display hours in 2-digit format
        minute: '2-digit', // Include minutes for a clear format
        omitZeroMinute: false, // Do not omit minutes
        hour12: false, // Use 24-hour format
        meridiem: false, // No AM/PM
      },

      timeZone: 'UTC',
      initialDate: this.getInitialDate(),

      datesSet: (arg) => {
        this.handleDateChange(arg);
      },

      eventMouseEnter: this.handleEventMouseEnter.bind(this),
      eventMouseLeave: this.handleEventMouseLeave.bind(this),

      eventDrop: this.handleEventDrop.bind(this), // Handle drag-and-drop
      eventResize: this.handleEventResize.bind(this), // Handle resizing
      eventDisplay: 'block',
      eventDidMount: (info) => {
        info.el.style.maxHeight = '100%';
        info.el.style.overflow = 'hidden';

        // This will ensure that the content doesn't make the event larger
        const titleEl = info.el.querySelector('.fc-event-title') as HTMLElement;
        if (titleEl) {
          titleEl.style.overflow = 'hidden';
          titleEl.style.textOverflow = 'ellipsis';
        }

        if (this.searchTerm !== '' && this.searchBookings.length > 0) {
          this.searchBookings.forEach((booking) => {
            if (booking.id && info.event.id === booking.id) {
              info.el.classList.add('found-booking');
            }
          });
        }
      },
    });

    this.calendarInitialized.set(true);
    this.calendarVisible.set(true);
  }

  onExpandCollapseDone(event: NgAnimationEvent): void {
    if (event.toState === 'expanded') {
      // FullCalendar often needs a size refresh after being uncollapsed
      requestAnimationFrame(() => {
        this.getCalendarApi()?.updateSize();
      });
    }
  }

  toggleChange() {
    this.changeBookingToggler = !this.changeBookingToggler;
  }

  onChangeModalClose(val: boolean) {
    if (val && this.editBooking) {
      this.bookingService.updateBookingChanges(this.editBooking);
    } else if (!val && this.oldBooking && this.editBooking) {
      const calApi = this.getCalendarApi();
      if (calApi) {
        const event = calApi.getEventById(this.oldBooking.id as string);
        if (event) {
          event.setStart(
            new Date(this.oldBooking.duration.startTime.seconds * 1000),
          );
          event.setEnd(
            new Date(this.oldBooking.duration.endTime.seconds * 1000),
          );

          event.setExtendedProp('booking', this.oldBooking);
        }
      }
    }

    this.toggleChange();
  }

  updateBookingOnResizeOrDrop(info: EventResizeDoneArg | EventDropArg) {
    if (info.event.start && info.event.end) {
      this.oldBooking = _.cloneDeep(
        info.event.extendedProps['booking'] as Booking,
      );
      // Kopie statt geteiltem Objekt, damit Abbrechen nichts in bookings[] stehen lässt
      const booking = _.cloneDeep(this.oldBooking);

      // Spread, damit optionale Felder (tourCode) beim Resize nicht verloren gehen
      booking.duration = {
        ...booking.duration,
        date: Timestamp.fromDate(info.event.start),
        startTime: Timestamp.fromDate(info.event.start),
        endTime: Timestamp.fromDate(info.event.end),
      };

      // Stellzeit = 15 min vor Beginn (wie guides.component); nur wenn sich der Beginn ändert,
      // sonst erzeugt ein reines Resize am Ende eine Guide-Änderung im Verlauf
      if (
        booking.guides &&
        booking.duration.startTime.seconds !==
          this.oldBooking.duration.startTime.seconds
      ) {
        const positionTime = Timestamp.fromMillis(
          info.event.start.getTime() - 15 * 60 * 1000,
        );
        Object.values(booking.guides).forEach((guide) => {
          if (!guide.positionDetails) return;
          guide.positionDetails = {
            ...guide.positionDetails,
            time: positionTime,
          };
        });
      }

      if (booking) {
        this.generateChangeBookingText(this.oldBooking, booking);
        this.editBooking = booking;
        this.toggleChange();
      }
    }
  }

  generateChangeBookingText(oldBooking: Booking, changeBooking: Booking) {
    // Zeiten sind UTC-Wanduhr (Kalender läuft mit timeZone 'UTC') → nicht in Browser-Zeit formatieren
    const day = (t: Timestamp) => format(utcCalendarDay(t.toDate()), 'dd.MM');
    const time = (t: Timestamp) => formatUnixToTimeString(t.seconds);
    const oldDate = day(oldBooking.duration.date);
    const oldStart = time(oldBooking.duration.startTime);
    const oldEnd = time(oldBooking.duration.endTime);
    const changeDate = day(changeBooking.duration.date);
    const changeStart = time(changeBooking.duration.startTime);
    const changeEnd = time(changeBooking.duration.endTime);

    this.changeBookingText = `Möchten Sie die Buchung vom <br>
<span class="font-bold">${oldDate}</span> von
<span class="font-bold">${oldStart}</span> bis
<span class="font-bold">${oldEnd}</span> auf <br>
<span class="font-bold">${changeDate}</span> von
<span class="font-bold">${changeStart}</span> bis
<span class="font-bold">${changeEnd}</span> ändern?
`;
  }

  handleEventResize(info: EventResizeDoneArg) {
    this.updateBookingOnResizeOrDrop(info);
  }

  handleEventDrop(info: EventDropArg) {
    this.updateBookingOnResizeOrDrop(info);
  }

  handleEventMouseEnter(info: any) {
    const booking = info.event.extendedProps['booking'] as Booking;
    let tooltipContent = '';
    if (booking) {
      // Generate the tooltip content
      tooltipContent = '<div>';

      // Iterate over all guides
      if (booking.guides) {
        let guides: newGuideInterface[] = [];
        if (booking.guideOrder) {
          guides = sortGuides(booking.guides, booking.guideOrder);
        } else {
          Object.entries(guides).forEach(([guideId, guide]) => {
            guides.push(guide);
          });
        }

        const tourcode = booking.duration.tourCode;
        if (tourcode) {
          tooltipContent += `
<div>
<strong>Tourcode: ${tourcode}</strong></div>
`;
        }

        const invoiceNr = booking.cruiseDetails?.invoiceNumber;
        if (invoiceNr) {
          tooltipContent += `
<div>
<strong>Auftragsnr.: ${invoiceNr}</strong></div>
`;
        }

        tooltipContent += '<hr>';
        // Add cruise details if available
        const cruiseDetails = booking.cruiseDetails;
        if (cruiseDetails) {
          tooltipContent += `
      <div>
        <strong>Cruise Details</strong><br>
        <ul>
          `;
          if (cruiseDetails.cruiseManager) {
            tooltipContent += `<li><strong>Manager:</strong> ${cruiseDetails.cruiseManager}</li>`;
          }
          if (cruiseDetails.paxShip) {
            tooltipContent += `<li><strong>Pax Ship:</strong> ${cruiseDetails.paxShip}</li>`;
          }
          if (cruiseDetails.paxTour) {
            tooltipContent += `<li><strong>Pax Tour:</strong> ${cruiseDetails.paxTour}</li>`;
          }

          tooltipContent += `
        </ul>
      </div>
    `;
        }

        const selectedBuses = booking.busInfos?.selectedBuses;
        if (!isEmpty(selectedBuses)) {
          tooltipContent += '<hr><div><strong>Busse</strong><ul>';
          Object.entries(selectedBuses)
            .filter(([_, amount]) => amount > 0)
            .forEach(([bus, amount]) => {
              tooltipContent += `<li>${bus}: ${amount}</li>`;
            });

          tooltipContent += '</ul></div>';
        }

        if (guides && guides.length > 0) {
          const guideCount = guides.filter((guide) => !guide.storno.isActive);
          tooltipContent +=
            '<hr><div><strong>Guides: ' + guideCount.length + '</strong></div>';
        }
      }

      const internNote = booking.cruiseDetails?.internNote;
      if (internNote) {
        tooltipContent += `<hr><div><strong>Interne Notiz:</strong> ${internNote}</div>`;
      }

      const billed = booking.accounting?.billing?.billed;
      if (billed) {
        tooltipContent += `<hr><div style="background-color: #dcfce7; color: #15803d; padding: 4px 4px; border-radius: 4px; margin-top: 4px;"><strong>Abgerechnet</strong></div>`;
      }

      tooltipContent += '</div>';
    }

    // Initialize Tippy tooltip
    tippy(info.el, {
      allowHTML: true,

      content: tooltipContent || 'NO DATA',
      placement: 'top',
      animation: 'fade',
      theme: 'light-border',
    });
  }

  handleEventMouseLeave(info: any) {
    // Destroy Tippy tooltip to avoid memory leaks
    if (info.el._tippy) {
      info.el._tippy.destroy();
    }
  }

  handleCalendarToggle() {
    this.calendarVisible.update((bool) => !bool);
  }

  handleDateChange(args: DatesSetArg) {
    if (args.start) {
      this.bookings$ = this.bookingService.getBookings(
        args.start,
        this.ship.id,
      );
    }
  }

  handleWeekendsToggle() {
    this.calendarOptions.update((options) => ({
      ...options,
      weekends: !options.weekends,
    }));
  }

  handleDateSelect(selectInfo: DateSelectArg) {
    const calendarApi = selectInfo.view.calendar;
    calendarApi.unselect(); // clear date selection
    const user = this.authService.getCurrentUser() as UserInterface;
    this.newBooking = {
      id: undefined,
      ship: this.ship,
      duration: {
        date: Timestamp.fromDate(selectInfo.start),
        startTime: Timestamp.fromDate(selectInfo.start),
        endTime: Timestamp.fromDate(selectInfo.end),
      },
      createdDate: Timestamp.fromDate(new Date()),
      userCreatorId: user.id,
      userCreatorName: user.username,
      //      lastEditDate: Timestamp.fromDate(new Date()),
      //    userLastEditorId: user.id,
      //   userLastEditorName: user.username,
    };

    this.toggleCalendarModal();
  }

  handleEventClick(clickInfo: EventClickArg) {
    if (clickInfo.event.extendedProps) {
      this.currentStartDate = clickInfo.event.start as Date;
      this.editBooking = clickInfo.event.extendedProps['booking'] as Booking;
      this.toggleCalendarEditModal();
    }
  }

  handleEvents(events: EventApi[]) {
    this.currentEvents.set(events);

    const bookingsFromEvents = events
      .map((event) => event.extendedProps['booking'] as Booking | undefined)
      .filter((booking): booking is Booking => Boolean(booking?.id));

    const uniqueById = new Map<string, Booking>();
    for (const booking of bookingsFromEvents) {
      uniqueById.set(booking.id as string, booking); // last wins
    }

    this.bookings = [...uniqueById.values()];
    this.checkEventVisibilty(this.showEmpty);
    this.changeDetector.detectChanges(); // workaround for pressionChangedAfterItHasBeenCheckedError
  }

  checkEventVisibilty(visbility: boolean) {
    if (!visbility && this.bookings.length === 0) {
      this.calendarVisible.set(false);
    } else {
      this.calendarVisible.set(true);
    }
  }

  onCloseCalendarModal(value: boolean) {
    if (value && this.newBooking) {
      this.bookingDataService.setBooking(this.newBooking);

      this.filterService.updateSearchTerm('');
      this.filterService.updateloadedBookings([]);
      this.router.navigate(['/booking/new']);
    }

    this.toggleCalendarModal();
  }

  onGoToDetailPage() {
    if (this.editBooking && this.currentStartDate) {
      const calendarWeek = getCalendarWeek(this.currentStartDate);

      const date = new Date(this.editBooking.duration.startTime.seconds * 1000);
      this.filterService.updateCalendarWeek(date.toISOString());
      this.filterService.updateSearchTerm('');
      this.filterService.updateloadedBookings([]);
      this.router.navigate([
        `booking/pdf-gen/${calendarWeek}/${this.editBooking.ship.id}/${this.editBooking.id}`,
      ]);
    }
  }

  prepareCopiedBooking(booking: Booking): Booking {
    booking.id = undefined;
    if (booking.duration.tourCode) {
      // booking.duration.tourCode = undefined;
    }

    booking.createdDate = Timestamp.fromDate(new Date());

    delete booking.hash;
    delete booking.voucher;
    delete booking.pdfUrl;

    const user = this.authService.getCurrentUser() as UserInterface;

    const changeAuthor = {
      id: user.id,
      name: user.username,
      email: user.email,
      tel: user.tel,
      title: user.title,
    };

    booking.changes = [];
    const copyChange: BookingChange = {
      timestamp: Timestamp.fromDate(new Date()),
      changeAuthor: changeAuthor,
      changeType: ChangeEventType.COPY,
      changes: { createdDate: Timestamp.fromDate(new Date()) },
    };
    booking.changes.push(copyChange);

    booking.userCreatorId = user.id;
    booking.userCreatorName = user.username;

    return booking;
  }

  onCopyBooking(booking: Booking) {
    const copiedBooking = _.cloneDeep(booking);
    this.prepareCopiedBooking(copiedBooking);
    this.bookingDataService.setBooking(copiedBooking);
    const date = new Date(booking.duration.startTime.seconds * 1000);
    this.filterService.updateCalendarWeek(date.toISOString());

    this.filterService.updateSearchTerm('');
    this.filterService.updateloadedBookings([]);
    this.router.navigate(['/booking/new']);
  }

  onCloseCalendarEditModal(value: boolean) {
    if (value && this.editBooking && this.currentStartDate) {
      this.bookingDataService.setBooking(this.editBooking);
      this.filterService.updateSearchTerm('');
      this.filterService.updateloadedBookings([]);
      const calendarWeek = getCalendarWeek(this.currentStartDate);
      this.router.navigate([
        `/booking/${calendarWeek}/${this.editBooking.ship.id}/${this.editBooking.id}`,
      ]);
    }

    this.toggleCalendarEditModal();
  }

  onDeleteBooking() {
    this.toggleCalendarEditModal();
    this.toggleCalendarDeleteModal();
  }

  onDeleteModalClose(value: boolean) {
    if (this.editBooking && value && this.currentStartDate) {
      this.bookingService.setDeleteFlagBooking(
        this.editBooking,
        this.currentStartDate,
      );
    }

    this.toggleCalendarDeleteModal();
  }
  toggleCalendarModal() {
    this.calendarModaltoggler = !this.calendarModaltoggler;
  }

  toggleCalendarEditModal() {
    this.calendarEditModaltoggler = !this.calendarEditModaltoggler;
  }

  toggleCalendarDeleteModal() {
    this.calendarDeleteModaltoggler = !this.calendarDeleteModaltoggler;
  }
}
